import { render, staticRenderFns } from "./SingleBorrower.vue?vue&type=template&id=9fd8784c"
import script from "./SingleBorrower.vue?vue&type=script&lang=js"
export * from "./SingleBorrower.vue?vue&type=script&lang=js"
import style0 from "./SingleBorrower.vue?vue&type=style&index=0&id=9fd8784c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports